import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navSections } from '@/lib/caseMeta';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  const jump = (id: string) => {
    setOpen(false);
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ${
        scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur-sm' : 'border-transparent bg-background-50'
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label="瓜田追踪 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg font-bold text-background-50">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">瓜田追踪</span>
            <span className="mt-0.5 text-[11px] tracking-wide text-foreground-500">不追首发 · 只追后续</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navSections.map((section) => (
            <Link
              key={section.id}
              to={`/#${section.id}`}
              onClick={() => jump(section.id)}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {section.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/#about"
            onClick={() => jump('about')}
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            追更提醒
          </Link>
          <button
            type="button"
            aria-label={open ? '关闭菜单' : '展开菜单'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-200 lg:hidden"
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex w-full flex-col gap-1 px-4 py-3 md:px-6" aria-label="移动端导航">
            {navSections.map((section) => (
              <Link
                key={section.id}
                to={`/#${section.id}`}
                onClick={() => jump(section.id)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
              >
                {section.label}
              </Link>
            ))}
            <Link
              to="/#about"
              onClick={() => jump('about')}
              className="mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              追更提醒
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;